interface PlaybackErrorAlertProps {
  message: string
  onRetry: () => void
}

export function PlaybackErrorAlert({ message, onRetry }: PlaybackErrorAlertProps) {
  return (
    <div
      className="mt-3 rounded-lg border border-yellow-500/50 bg-yellow-500/10 px-3 py-2 text-xs text-yellow-200"
      role="status"
      aria-live="polite"
    >
      <div className="flex items-center justify-between gap-3">
        <span>{message}</span>
        <button
          onClick={onRetry}
          className="text-yellow-200 underline underline-offset-2 hover:text-white focus:outline-none focus:ring-2 focus:ring-yellow-400 rounded px-2 py-1"
        >
          Retry
        </button>
      </div>
    </div>
  )
}
